import { Table as MuiTable, styled, tableRowClasses } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { tableCellClasses } from './TableCell';
const defaultSideCellSpacing = 1;
export const TableStyled = styled(MuiTable, shouldNotForwardProps('striped', 'sideCellSpacing'))(({ theme, striped, sideCellSpacing = defaultSideCellSpacing }) => ({
    [`.${tableCellClasses.root}`]: {
        '&:first-of-type': {
            paddingLeft: theme.spacing(sideCellSpacing),
        },
        '&:last-of-type': {
            paddingRight: theme.spacing(sideCellSpacing),
        },
    },
    ...(striped && {
        [`.${tableRowClasses.root}`]: {
            [`&:nth-of-type(${striped === 'odd' ? 'odd' : 'even'})`]: {
                backgroundColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 2.5%, transparent)`,
            },
            '&:not(:first-of-type)': {
                [`.${tableCellClasses.root}`]: {
                    borderTop: 'none',
                },
            },
        },
    }),
}));
